import { useEffect, useRef } from 'react';
import { RecommendationLabel } from '@wix/ambassador-premium-domains-v1-recommendation/types';
import { tldAlternativesApiClient } from '../Components/TldAlternativesWithPrice/TldAlternativesWithPrice.apiClient';
import { DomainSearchGateModule } from '../module/domainSearchGate.module';
const toBiSuggestions = (recommendations, inHeroCard) => recommendations.map(rec => ({
  domain: rec.domain || '',
  isPremiumDomain: rec.premium || false,
  inHeroCard
}));
const stringifySuggestions = suggestions => JSON.stringify(suggestions.map(sug => ({
  domain: sug.domain,
  isPremium: sug.isPremiumDomain,
  in_hero_card: sug.inHeroCard
})));
export const useResultsPageOfferingsBi = _ref => {
  var _recommendations$;
  let {
    recommendations,
    isLoading,
    includeHeroCardOffers = false,
    enabled = true,
    biError
  } = _ref;
  useEffect(() => {
    if (biError) {
      DomainSearchGateModule.internals.bi.onResultsPageError == null || DomainSearchGateModule.internals.bi.onResultsPageError({
        errorType: biError
      });
    }
  }, [biError]);
  const isExactMatchHero = ((_recommendations$ = recommendations[0]) == null ? void 0 : _recommendations$.label) === RecommendationLabel.EXACT_MATCH;
  const hero = includeHeroCardOffers || isExactMatchHero ? recommendations[0] : undefined;
  const list = hero ? recommendations.slice(1) : recommendations;
  const heroDomain = includeHeroCardOffers ? (hero == null ? void 0 : hero.domain) ?? '' : '';
  const isHeroAltsEnabled = Boolean(heroDomain);
  const {
    data: heroAltsData,
    error: heroAltsError
  } = tldAlternativesApiClient.hooks.useTldAlternatives({
    heroDomain
  }, isHeroAltsEnabled, {
    useErrorBoundary: false
  });
  const heroAlternatives = (heroAltsData == null ? void 0 : heroAltsData.alternatives) ?? [];
  const isHeroAltsSettled = !isHeroAltsEnabled || heroAltsData !== undefined || heroAltsError !== null;
  const lastFiredResultsLoadKeyRef = useRef('');
  useEffect(() => {
    if (!enabled || isLoading || recommendations.length === 0) {
      return;
    }
    if (!isHeroAltsSettled) {
      return;
    }
    const suggestions = hero ? [...toBiSuggestions([hero], true), ...toBiSuggestions(heroAlternatives, true), ...toBiSuggestions(list, false)] : toBiSuggestions(recommendations, false);
    const resultsKey = suggestions.map(s => `${s.domain}:${s.inHeroCard ? 1 : 0}`).join(',');
    if (resultsKey !== lastFiredResultsLoadKeyRef.current) {
      lastFiredResultsLoadKeyRef.current = resultsKey;
      DomainSearchGateModule.internals.bi.onResultsPageLoad == null || DomainSearchGateModule.internals.bi.onResultsPageLoad({
        type: 'suggestions',
        suggestions,
        hero_card_offers: includeHeroCardOffers ? stringifySuggestions(toBiSuggestions(heroAlternatives, true)) : undefined
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [enabled, isLoading, recommendations.length, includeHeroCardOffers, isExactMatchHero, isHeroAltsSettled, heroAlternatives.length]);
};
//# sourceMappingURL=useResultsPageOfferingsBi.js.map